/* テキスト */
import React, { memo, useState } from 'react';
import { FormControl, Col, Row } from 'react-bootstrap';
import RowTemplate from '../atoms/RowTemplate';
import Messages from '../molecules/Messages';
import Paragraph from '../atoms/Paragraph';
import { convert_types, mask_string } from '../Const';
import { convertData } from '../Convert';
var Text = function (_a) {
    var id = _a.id, fm_id = _a.fm_id, label = _a.label, type = _a.type, need = _a.need, value = _a.value, placeholder = _a.placeholder, handleChange = _a.handleChange, message = _a.message, name = _a.name, suffix = _a.suffix, help_msg = _a.help_msg, disabled = _a.disabled, readonly = _a.readonly, maxlength = _a.maxlength, handleBlur = _a.handleBlur, handleFocus = _a.handleFocus, add_comma = _a.add_comma, input_assistance = _a.input_assistance;
    var _b = useState(true), is_init = _b[0], setIsInit = _b[1];
    var returnTextFormJsx = function () {
        /**
         * フォーカスイベント
         * @param event イベントオブジェクト
         */
        var handleFocusInput = function (event) {
            // 1回目のフォーカスで初期表示フラグを倒す
            if (is_init) {
                setIsInit(false);
            }
            // props.handleFocusがundefinedでなければメソッドを実行する
            if (typeof handleFocus !== 'undefined') {
                handleFocus(event);
            }
        };
        /**
         * 値をセットする
         * @returns value 値（初期表示時はコンバート後の文字列）
         */
        var setValue = function () {
            // input_assistanceがセットされていて、初期表示の時はデータコンバートを行う
            if (typeof input_assistance !== 'undefined' && is_init) {
                return convertData(input_assistance, value);
            }
            return value;
        };
        return suffix ? (React.createElement(React.Fragment, null,
            React.createElement(Row, null,
                React.createElement(Col, null,
                    React.createElement(FormControl, { id: id, "data-fm_id": fm_id, type: type, placeholder: placeholder, value: setValue(), onChange: handleChange, name: name, disabled: disabled, readOnly: readonly, onBlur: handleBlur, onFocus: handleFocusInput, maxLength: maxlength })),
                React.createElement(Col, { md: 2, lg: 2, xl: 2 }, suffix)),
            React.createElement(Messages, { help_msg: help_msg, valid_msg: message }))) : (React.createElement(React.Fragment, null,
            React.createElement(FormControl, { id: id, "data-fm_id": fm_id, type: type, value: setValue(), onChange: handleChange, placeholder: placeholder, name: name, disabled: disabled, readOnly: readonly, onBlur: handleBlur, onFocus: handleFocusInput, maxLength: maxlength }),
            React.createElement(Messages, { help_msg: help_msg, valid_msg: message })));
    };
    var returnLabelJsx = function () {
        // valueをセット
        // NOTE input_assistanceにaddCommaが指定されている場合、カンマ区切りを実行する。
        var label_value = add_comma ? convertData(convert_types.add_comma, value) : value;
        // suffixをセット
        var label_suffix = suffix !== null && typeof suffix !== 'undefined' ? suffix : '';
        // マスク文字列
        var masked_value = ''; // 初期化
        if ((type === null || type === void 0 ? void 0 : type.toLowerCase()) === 'password' && value !== null && typeof value !== 'undefined') {
            for (var i = 0; i < value.length; i++) {
                masked_value += mask_string;
            }
        }
        return (type === null || type === void 0 ? void 0 : type.toLowerCase()) === 'password' ? (React.createElement(Row, null,
            React.createElement(Col, null,
                React.createElement(Paragraph, { label: "" + masked_value + label_suffix })))) : (React.createElement(Row, null,
            React.createElement(Col, null,
                React.createElement(Paragraph, { label: "" + label_value + label_suffix }))));
    };
    return (React.createElement(RowTemplate, { label: label, need: need, disabled: disabled, content: disabled ? returnLabelJsx() : returnTextFormJsx() }));
};
export default memo(Text);
